var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"WidgetTop-Section"},[_c('b-row',[_c('b-col',{staticClass:"mobileWid",attrs:{"lg":"12","md":"12"}},[_c('div',{staticClass:"contentBlock"},[_c('span',{staticClass:"titleRound",style:(_vm.colourTour)},[(_vm.currentTitle == 'Live Scoring Monitor')?[_vm._v(" Latest Scores ")]:[_vm._v(" "+_vm._s(_vm.currentTitle)+" ")]],2),_c('span',{staticClass:"tourName hideFullName"},[_vm._v(" "+_vm._s(_vm.TourName)+" ")]),_c('span',{staticClass:"tourName hideShortName"},[_vm._v(" "+_vm._s(_vm.mobName)+" ")])])])],1)],1),(_vm.data.stableford == 'Y' || _vm.data.tt_code == 'B')?[(_vm.currentTitle.includes('Score'))?[_c('ScoreTeamSST',{attrs:{"data":_vm.data,"title":_vm.title,"home":true,"updown":_vm.updown,"config":_vm.config,"team":_vm.teamEvent,"match":_vm.match,"tour":_vm.tour,"ReportcolourTour":_vm.ReportcolourTour,"Stableford":_vm.Stableford}})]:[_c('ReportTable',{attrs:{"data":_vm.data,"title":_vm.title,"home":true,"updown":_vm.updown,"config":_vm.config,"team":_vm.teamEvent,"match":_vm.match,"tour":_vm.tour,"ReportcolourTour":_vm.ReportcolourTour,"Stableford":_vm.Stableford}})]]:[_c('ReportTable',{attrs:{"data":_vm.data,"title":_vm.title,"home":true,"updown":_vm.updown,"config":_vm.config,"team":_vm.teamEvent,"match":_vm.match,"tour":_vm.tour,"ReportcolourTour":_vm.ReportcolourTour,"Stableford":_vm.Stableford}})],_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.livemessage == 'Y' || _vm.playSuspended == 'Y'),expression:"livemessage == 'Y' || playSuspended == 'Y'"}],staticClass:"livemessage",class:{ colorMess: _vm.playSuspended == 'Y' }},[_c('div',[_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.playSuspended == 'Y'),expression:"playSuspended == 'Y'"}],staticClass:"livemestext"},[_vm._v(" Play Suspended ")]),_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.livemessage == 'Y' && _vm.livemessageText.length > 0),expression:"livemessage == 'Y' && livemessageText.length > 0"}],staticClass:"livemestext"},[_vm._v(" "+_vm._s(_vm.livemessageText)+" ")])])]),_c('b-nav',{staticClass:"fullListings",attrs:{"small":""}},[_c('b-container',{staticStyle:{"display":"contents"}},[(_vm.title === 'Tournament Entries')?_c('b-nav-item',{staticClass:"Flisting-btn right",class:{
          backgroundColourTourcpt: _vm.tour == 'cpt',
          backgroundColourTourcp2: _vm.tour == 'cp2',
          backgroundColourTourcp3: _vm.tour == 'cp3',
          backgroundColourTourpam: _vm.tour == 'pam',
          backgroundColourTourpor: _vm.tour == 'por',
          backgroundColourTourqsc: _vm.tour == 'qsc',
        },attrs:{"to":{
          name: 'reports',
          query: {
            url:
              'tmentry.cgi?tourn=' +
              _vm.courseCode +
              '~season=' +
              _vm.Year +
              '~alphaorder~',
            id: _vm.Year,
            code: _vm.courseCode,
            title: 'Tournament Entries',
            tour: _vm.tour,
          },
        }}},[_c('span',{staticClass:"black"}),_vm._v(" See Full Listing ")]):_vm._e(),(_vm.title === 'Final Result')?_c('b-nav-item',{staticClass:"Flisting-btn right",class:{
          backgroundColourTourcpt: _vm.tour == 'cpt',
          backgroundColourTourcp2: _vm.tour == 'cp2',
          backgroundColourTourcp3: _vm.tour == 'cp3',
          backgroundColourTourpam: _vm.tour == 'pam',
          backgroundColourTourpor: _vm.tour == 'por',
          backgroundColourTourqsc: _vm.tour == 'qsc',
        },style:(_vm.colourTour),attrs:{"to":{
          name: 'reports',
          query: {
            url:
              'tmresult.cgi?tourn=' +
              _vm.courseCode +
              '~season=' +
              _vm.Year +
              'result=PF~&',
            id: _vm.Year,
            code: _vm.courseCode,
            title: 'Final Result',
            tour: _vm.tour,
          },
        }}},[_c('span',{staticClass:"black"}),_vm._v(" See Full Listing ")]):_vm._e(),(_vm.currentReport.includes('score'))?_c('b-nav-item',{staticClass:"right four Flisting-btn",class:{pulse: _vm.live_scoring == 'Y',
          backgroundColourTourcpt: _vm.tour == 'cpt',
          backgroundColourTourcp2: _vm.tour == 'cp2',
          backgroundColourTourcp3: _vm.tour == 'cp3',
          backgroundColourTourpam: _vm.tour == 'pam',
          backgroundColourTourpor: _vm.tour == 'por',
          backgroundColourTourqsc: _vm.tour == 'qsc',
        },attrs:{"to":{
          name: 'reports',
          query: {
            url: _vm.reportURL,
            id: _vm.Year,
            code: _vm.courseCode,
            title: _vm.title,
            tour: _vm.tour,
            home:true
          },
        }}},[_c('span',{staticClass:"black"}),_vm._v(" See Full Listing ")]):_vm._e()],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }